const OPEN_DRAWER = 'OPEN_DRAWER'
const CLOSE_DRAWER = 'CLOSE_DRAWER'
const EXPAND_DRAWER = 'EXPAND_DRAWER'
const COLLAPSE_DRAWER = 'COLLAPSE_DRAWER'
const UPDATE_DRAWER_SCROLLBAR_DATA = 'UPDATE_DRAWER_SCROLLBAR_DATA'

export const DRAWER_COLLAPSED_LOCAL_STORAGE_KEY = 'portalDrawerCollapsed'

const defaultState = {
  open: false,
  collapsed: localStorage.getItem(DRAWER_COLLAPSED_LOCAL_STORAGE_KEY) === 'true',
  scrollbarData: { visible: false, width: 0 },
}

const drawer = {
  name: 'drawer',
  reducer: (state, action) => {
    switch (action.type) {
      case OPEN_DRAWER:
        return { ...state, open: true }
      case CLOSE_DRAWER:
        return { ...state, open: false }
      case EXPAND_DRAWER: {
        if (action.updateLocalStorage) {
          localStorage.setItem(DRAWER_COLLAPSED_LOCAL_STORAGE_KEY, false)
        }
        return { ...state, collapsed: false }
      }
      case COLLAPSE_DRAWER: {
        localStorage.setItem(DRAWER_COLLAPSED_LOCAL_STORAGE_KEY, true)
        return { ...state, collapsed: true }
      }
      case UPDATE_DRAWER_SCROLLBAR_DATA:
        return { ...state, scrollbarData: action.data }
      default:
        return state || defaultState
    }
  },
  selectDrawerOpen: (state) => state.drawer.open,
  selectDrawerCollapsed: (state) => state.drawer.collapsed,
  selectDrawerScrollbarData: (state) => state.drawer.scrollbarData,
  doCloseDrawer:
    () =>
    ({ dispatch }) =>
      dispatch({ type: CLOSE_DRAWER }),
  doOpenDrawer:
    () =>
    ({ dispatch }) =>
      dispatch({ type: OPEN_DRAWER }),
  doExpandDrawer:
    ({ updateLocalStorage = true } = {}) =>
    ({ dispatch }) =>
      dispatch({ type: EXPAND_DRAWER, updateLocalStorage }),
  doCollapseDrawer:
    () =>
    ({ dispatch }) =>
      dispatch({ type: COLLAPSE_DRAWER }),
  doUpdateDrawerScrollbarData:
    (payload) =>
    ({ dispatch }) =>
      dispatch({ type: UPDATE_DRAWER_SCROLLBAR_DATA, data: payload }),
}

export default drawer
